import * as Types from '../../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateCaregiverMutationVariables = Types.Exact<{
  organisationUuid: Types.Scalars['String']['input'];
  caregiverData: Types.CaregiverMemberInput;
}>;


export type CreateCaregiverMutation = { __typename?: 'Mutation', createCaregiverMember: { __typename?: 'OrganisationMemberUser', id: string, role: Types.OrganisationRole, user: { __typename?: 'User', id: string, uuid: string, firstName?: string | null, lastName?: string | null, email?: string | null, username: string, telephone?: string | null } } };


export const CreateCaregiverDocument = gql`
    mutation CreateCaregiver($organisationUuid: String!, $caregiverData: CaregiverMemberInput!) {
  createCaregiverMember(organisationUuid: $organisationUuid, data: $caregiverData) {
    id
    role
    user {
      id
      uuid
      firstName
      lastName
      email
      username
      telephone
    }
  }
}
    `;
export type CreateCaregiverMutationFn = Apollo.MutationFunction<CreateCaregiverMutation, CreateCaregiverMutationVariables>;

/**
 * __useCreateCaregiverMutation__
 *
 * To run a mutation, you first call `useCreateCaregiverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaregiverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaregiverMutation, { data, loading, error }] = useCreateCaregiverMutation({
 *   variables: {
 *      organisationUuid: // value for 'organisationUuid'
 *      caregiverData: // value for 'caregiverData'
 *   },
 * });
 */
export function useCreateCaregiverMutation(baseOptions?: Apollo.MutationHookOptions<CreateCaregiverMutation, CreateCaregiverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCaregiverMutation, CreateCaregiverMutationVariables>(CreateCaregiverDocument, options);
      }
export type CreateCaregiverMutationHookResult = ReturnType<typeof useCreateCaregiverMutation>;
export type CreateCaregiverMutationResult = Apollo.MutationResult<CreateCaregiverMutation>;
export type CreateCaregiverMutationOptions = Apollo.BaseMutationOptions<CreateCaregiverMutation, CreateCaregiverMutationVariables>;